import {Component, OnInit, ViewChild} from '@angular/core';
import {DataTableDirective} from 'angular-datatables';
import {SubscriptionsService} from '../../services/subscriptions.service';
import * as FileSaver from 'file-saver';
import {ToastrService} from "ngx-toastr";


@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss']
})
export class SubscriptionsComponent implements OnInit {

  dtOptions: DataTables.Settings = {};
  items: any[];
  @ViewChild(DataTableDirective) private dtElement;
  exporting = false;

  constructor(
      private subscriptionsService: SubscriptionsService,
  ) {
  }

  ngOnInit(): void {
      this.dtOptions = {
          pagingType: 'full_numbers',
          pageLength: 10,
          serverSide: true,
          processing: true,
          ajax: (dataTablesParameters: any, callback) => {
              this.subscriptionsService.datatable(dataTablesParameters)
                  .subscribe(response => {
                      this.items = response.data;
                      callback({
                          recordsTotal: response.recordsTotal,
                          recordsFiltered: response.recordsFiltered,
                          data: []
                      });
                  });
          },
          columns: [
                {data: 'plan'},
                {data: 'name'},
                {data: 'last_name'},
                {data: 'email'},
                {data: 'phone'},
                {data: 'document_number'},
          ]
      };
  }

  private async reloadTable() {
      let dtIntance = await this.dtElement.dtInstance;
      dtIntance.ajax.reload();
  }

}
